import request from '@/config/axios'

// 查询全部区域
export const getRegionSimpleList = () => {
  return request.get({ url: '/system/business-region/simple-list' })
}

// 查询区域（精简）列表
export const getBusinessRegionList = () => {
  return request.get({ url: '/system/business-region/simple-list' })
}
